import * as React from 'react';
import { Row, Col } from 'react-bootstrap';

import type { W_Employee_FindById_VM } from 'ab-api/web/employee/findById';

import { BlobStorageImageSizeContainer } from '@acceligentllc/shared/enums/blobStorageImageSizeContainer';
import type { CDLStatus } from '@acceligentllc/shared/enums/cdlStatus';
import { CDLStatusLabel } from '@acceligentllc/shared/enums/cdlStatus';

import { AVAILABLE_EMPLOYEE_STATUS } from 'ab-common/constants/employee';
import { DEFAULT_EMPLOYEE_IMAGE } from 'ab-common/constants/value';

import ImageTag from 'af-components/Image';
import LabelWithPills from 'af-components/LockedPillsValue';
import LockedValue from 'af-components/LockedValue';
import StatusLabel from 'af-components/StatusLabel';

import EmployeeCredentials from './EmployeeCredentials';
import styles from './styles.module.scss';

interface OwnProps {
	employee: W_Employee_FindById_VM;
}

type Props = OwnProps;

const formatCDLStatus = (cdlStatus: CDLStatus) => CDLStatusLabel[cdlStatus];
const formatShowOnScheduleBoard = (showOnScheduleBoard: boolean) => showOnScheduleBoard ? 'Yes' : 'No';

const EmployeePreview: React.FC<Props> = (props) => {
	const { employee } = props;

	return (
		<>
			<div className={styles['preview-container']}>
				<Row className="row">
					<div className={styles['section-title']}>
						Personal information
					</div>
				</Row>
				<Row className="row row--flex">
					<div className="avatar__container">
						<div className="avatar">
							<ImageTag
								fallbackSrc={DEFAULT_EMPLOYEE_IMAGE}
								minSize={BlobStorageImageSizeContainer.SIZE_200X200}
								src={employee.imageUrl as string}
								tryOriginal={true}
								tryRoot={true}
							/>
						</div>
					</div>
					<div className="avatar__neighbour">
						<Row className="row--padded">
							<Col md={6}><LockedValue defaultValue="N/A" label="Name" value={employee.fullName} /></Col>
							<Col md={6}>
								<LockedValue
									defaultValue="N/A"
									label="Current Status"
									value={
										<StatusLabel
											isAvailable={!!employee.isStatusAvailable}
											label={employee.employeeStatusName ?? AVAILABLE_EMPLOYEE_STATUS}
										/>
									}
								/>
							</Col>
							<Col md={6}><LockedValue defaultValue="N/A" label="Mobile Phone" value={employee.phoneNumber} /></Col>
							<Col md={6}><LockedValue defaultValue="N/A" label="SMS Subscription" value={employee.subscriptionStatus} /></Col>
						</Row>
						<Row className="row--padded-bottom">
							<Col md={6}><LockedValue defaultValue="N/A" label="Location" value={employee.locationNickname} /></Col>
							<Col md={6}><LockedValue defaultValue="N/A" label="CDL Status" value={formatCDLStatus(employee.cdlStatus)} /></Col>
							<Col md={12}><LockedValue defaultValue="N/A" label="E-mail" value={employee.email} /></Col>
						</Row>
						<Row>
							<Col md={6}><LockedValue defaultValue="N/A" label="Labor Type" value={employee?.wageRate?.wageClassification} /></Col>
							<Col md={6}><LockedValue defaultValue="N/A" label="Wage Classification" value={employee?.wageRate?.type} /></Col>
							<Col md={6}><LockedValue defaultValue="N/A" label="Union Type" value={employee?.unionType?.name} /></Col>
							<Col md={6}><LockedValue defaultValue="N/A" label="Visible on Schedule Board" value={formatShowOnScheduleBoard(employee.showOnScheduleBoard)} /></Col>
						</Row>
					</div>
				</Row>
				<Row className="row row--flex">
					<Col md={24}>
						<LabelWithPills
							colorKey="color"
							items={employee.skills}
							label="Skills"
							labelKey="name"
						/>
					</Col>
				</Row>

			</div>
			<div className={styles['preview-container']}>
				<Row className="row">
					<div className={styles['section-title']}>
						Credentials
					</div>
				</Row>
				<Row className="row">
					<EmployeeCredentials
						credentials={employee.credentials}
					/>
				</Row>
			</div>
		</>
	);
};

export default React.memo(EmployeePreview);
